module.exports = __webpack_public_path__ + "assets/fonts/opensans-bold_1d9c794.eot";